
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { startOfMonth, endOfMonth } from "date-fns";

export const useMonthlyStats = () => {
  return useQuery({
    queryKey: ["monthly_profit"],
    queryFn: async () => {
      const startDate = startOfMonth(new Date());
      const endDate = endOfMonth(new Date());

      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error("Non authentifié");

      // Récupérer les revenus validés de la même manière que l'onglet Historique
      const { data: validatedAmounts, error: validatedError } = await supabase
        .from("poultry_transactions")
        .select("total_amount")
        .eq("transaction_type", "sale")
        .eq("is_deducted_from_revenue", true)
        .eq("created_by", user.id)
        .gte("created_at", startDate.toISOString())
        .lte("created_at", endDate.toISOString());

      if (validatedError) throw validatedError;

      // Récupérer les dépenses
      const { data: expenses, error: expensesError } = await supabase
        .from("poultry_transactions")
        .select("total_amount")
        .eq("transaction_type", "expense")
        .eq("created_by", user.id)
        .gte("created_at", startDate.toISOString())
        .lte("created_at", endDate.toISOString());

      if (expensesError) throw expensesError;

      // Calculer les totaux
      const totalRevenue = validatedAmounts?.reduce((sum, record) => sum + (record.total_amount || 0), 0) || 0;
      const totalExpenses = expenses?.reduce((sum, record) => sum + (record.total_amount || 0), 0) || 0;
      const netProfit = totalRevenue - totalExpenses;
      const profitMargin = totalRevenue > 0 ? (netProfit / totalRevenue) * 100 : 0;

      return {
        revenue: totalRevenue,
        expenses: totalExpenses,
        netProfit,
        profitMargin
      };
    }
  });
};
